import { Typography } from 'antd';
const { Title } = Typography;
interface CardTitleProps {
  title: string;
}
export default function CardTitle({ title }: CardTitleProps) {
  return (
    <div className="cover-title">
      <Title className="title" level={4} ellipsis={{ rows: 3 }}>
        {title}
      </Title>
    </div>
  );
}
